var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.875C26.303 33.875 33.875 26.303 33.875 17C33.875 7.69698 26.303 0.125 17 0.125C7.69698 0.125 0.125 7.69698 0.125 17C0.125 26.303 7.69698 33.875 17 33.875ZM28.0885 9.12319C29.7379 11.4367 30.6089 14.1639 30.6089 17C30.6089 24.5067 24.5067 30.6089 17 30.6089C14.1585 30.6089 11.4367 29.7379 9.12319 28.0831L8.60061 27.7075L27.7183 8.58972L28.094 9.1123L28.0885 9.12319ZM17 3.39113C19.8361 3.39113 22.5633 4.2621 24.8768 5.91694L25.3994 6.29254L6.28165 25.4103L5.90605 24.8877C4.25665 22.5742 3.38569 19.847 3.38569 17.0109C3.38569 9.50423 9.4879 3.40202 16.9946 3.40202L17 3.39113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.a1c2739b3d404f29cd417e2bc1d5cea0.svg";
export { ForwardRef as ReactComponent };